import { CommonService } from './../../../services/common.service';
import { CommonMessageService } from 'src/app/services/common-message.service';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss'],
})
export class ContactUsComponent implements OnInit {
  contactUsForm: FormGroup;
  @Input() data;
  constructor(private modalController: ModalController,
    private commonMessager: CommonMessageService,
    private common: CommonService, private fb: FormBuilder, ) { }

  ngOnInit() {
    this.buildForm();
  }

  private buildForm() {
    console.log('data: ', this.data);
    this.contactUsForm = this.fb.group({
      nom: [this.data && this.data.nom, [Validators.required]],
      prenom: [this.data && this.data.prenom, [Validators.required]],
      telephone: [this.data && this.data.telephones, [Validators.required]],
      email: [this.data && this.data.loginEmail, [Validators.required]],
      message: ['', [Validators.required]],
    });
  }

  close(data?) {
    this.modalController.dismiss(data);
  }


  async contactUs() {
    const loading = await this.commonMessager.loading('Patientez un instant');
    try {
      const dataToSend = this.contactUsForm.value;
      const data = (await this.common.contactUs(dataToSend).toPromise()) as any;
      await this.commonMessager.successToast('Votre message a été envoyé, merci de votre confiance.');
      window.location.href = '';
    } catch (error) {
      this.commonMessager.errorToast('Erreur:  ' + error);
    } finally {
      loading.dismiss();
    }
  }
}
